import { API_URL } from "@/lib/api";
const BACKEND_URL = API_URL;

export const copyToClipboard = async (text) => {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      // Clipboard API failed, fall through to execCommand
    }
  }
  const el = document.createElement('textarea');
  el.value = text;
  el.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;pointer-events:none';
  document.body.appendChild(el);
  el.focus(); el.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(el);
  return ok;
};

export const topFrameDownload = (filename, customUrl) => {
  const url = customUrl || `${BACKEND_URL}/api/reports/download/${filename}`;
  try {
    window.top.location.href = url;
  } catch (err) {
    window.location.href = url;
  }
};

export const parseCSV = (text) => {
  const lines = text.replace(/^\uFEFF/, '').split('\n').filter(l => l.trim());
  return lines.map(line => {
    const row = []; let inQuotes = false; let current = '';
    for (const char of line) {
      if (char === '"') { inQuotes = !inQuotes; }
      else if (char === ',' && !inQuotes) { row.push(current.trim()); current = ''; }
      else { current += char; }
    }
    row.push(current.trim()); return row;
  });
};

export const parseExcel = async (blob) => {
  const { read, utils } = await import('xlsx');
  const data = await blob.arrayBuffer();
  const wb = read(data);
  const ws = wb.Sheets[wb.SheetNames[0]];
  const rows = utils.sheet_to_json(ws, { header: 1, defval: '' });
  return rows.map(r => r.map(c => String(c)));
};
